import { cn } from '@/lib/utils';

export function Kbd({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <kbd
      className={cn(
        'inline-flex items-center justify-center min-w-[24px] h-6 px-1.5 rounded-md',
        'bg-bg-muted border border-border text-[11px] font-medium text-fg font-mono leading-none',
        className,
      )}
    >
      {children}
    </kbd>
  );
}
